import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var KeyboardSVG = function KeyboardSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29,6H3A1,1,0,0,0,2,7V23a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V7A1,1,0,0,0,29,6ZM15,10h2v2H15Zm0,4h2v2H15Zm-4-4h2v2H11Zm0,4h2v2H11ZM9,20H7V18H9Zm0-4H7V14H9Zm0-4H7V10H9Zm12,8H11V18H21Zm0-4H19V14h2Zm0-4H19V10h2Zm4,8H23V18h2Zm0-4H23V14h2Zm0-4H23V10h2Z"
  }));
};
KeyboardSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(KeyboardSVG);